import React from 'react';
import Select, { selectType } from 'Components/Select';

export default class CombinationSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTypes: {},
    };
  }

  isMaxComponents = rule => {
    const { boatSystems, currentSystem } = this.props;
    const activeSystem = boatSystems[currentSystem.index];

    const ruleValueRequest = activeSystem.ruleValueRequests
      ? activeSystem.ruleValueRequests.find(element => element.ruleId === rule.id)
      : null;
    if (ruleValueRequest && ruleValueRequest.componentIdWithQuantityMap) {
      if (Object.keys(ruleValueRequest.componentIdWithQuantityMap).length === rule.maxComponentQuantity) return 'equal';
      if (Object.keys(ruleValueRequest.componentIdWithQuantityMap).length > rule.maxComponentQuantity) return 'more';
    }
    return '';
  };

  handleSelectComponent = ruleId => component => {
    const { selectComponent } = this.props;

    selectComponent(ruleId, component);
  };

  getSelectedType = (rule, availableTypesList) => {
    const { selectedTypes } = this.props;
    return availableTypesList.find(type => {
      return type.typeId === selectedTypes[rule.id];
    });
  };

  getAvailableComponentsList = ruleId => {
    const { selectedTypes, boatSystems, currentSystem, allComponents, selectedManufacturersFilters } = this.props;
    const activeSystem = boatSystems[currentSystem.index];

    const ruleValueRequest = activeSystem.ruleValueRequests
      ? activeSystem.ruleValueRequests.find(rule => rule.ruleId === ruleId)
      : null;

    if (!selectedTypes[ruleId] || !allComponents[selectedTypes[ruleId]]) return [];
    if (!ruleValueRequest)
      return allComponents[selectedTypes[ruleId]].filter(component => {
        return (
          !selectedManufacturersFilters[ruleId] || component.manufacturerName === selectedManufacturersFilters[ruleId]
        );
      });

    return allComponents[selectedTypes[ruleId]].filter(component => {
      return (
        !ruleValueRequest.componentIdWithQuantityMap[component.id] &&
        (!selectedManufacturersFilters[ruleId] || component.manufacturerName === selectedManufacturersFilters[ruleId])
      );
    });
  };

  getAddedComponentsList = combinationSingleTypeHolder => {
    const { savedComponents, boatSystems, currentSystem } = this.props;
    const activeSystem = boatSystems[currentSystem.index];

    let typeHolderComponents = activeSystem.ruleValueRequests
      ? activeSystem.ruleValueRequests.find(ruleElement => ruleElement.ruleId === combinationSingleTypeHolder.id)
      : null;

    if (typeHolderComponents) {
      return Object.keys(typeHolderComponents.componentIdWithQuantityMap)
        .map(key => {
          let component = savedComponents.find(component => component.id === +key);
          if (component) component.quantity = typeHolderComponents.componentIdWithQuantityMap[key];
          return component;
        })
        .filter(component => component);
    } else {
      return [];
    }
  };

  getStyle = rule => {
    const { currentSystem, invalidList } = this.props;

    if (this.isMaxComponents(rule)) return 'filled';
    if (invalidList[currentSystem.index] && invalidList[currentSystem.index][rule.id]) return 'error';
    return '';
  };

  hasInvalidComponents = () => {
    const { selectedCombination, invalidComponents } = this.props;

    let isBad = false;

    selectedCombination.requiredRules.forEach(rule => {
      const components = this.getAddedComponentsList(rule);
      components.forEach(component => {
        if (invalidComponents[component.id]) isBad = true;
      });
    });

    return isBad;
  };

  getAvailableTypesList = componentTypeIds => {
    const { allTypes } = this.props;

    return componentTypeIds
      .map(typeId => {
        const typeData = allTypes.find(type => +type.id === +typeId);
        if (typeData.active) {
          return {
            typeId,
            value: typeData.componentTypeName,
          };
        } else {
          return null;
        }
      })
      .filter(type => type);
  };

  render() {
    const {
      boatSystems,
      currentSystem,
      selectedCombination,
      removeComponent,
      updateQuantity,
      invalidComponents,
      handleTypeChose,
      selectSingleType,
      loadedTypes,
      selectedTypes,
      getCombinationCompositionReminder,
      manufacturersList,
      handleSelectManufacturerFilter,
      selectedManufacturersFilters,
    } = this.props;
    const activeSystem = boatSystems[currentSystem.index];

    if (!activeSystem) return null;

    return (
      <section className='scene_section system-configuration-section'>
        <header>Add Components</header>
        {currentSystem.combinations.length <= 1 && getCombinationCompositionReminder()}
        {this.hasInvalidComponents() && (
          <div className='type-set-quantity-label error'>
            One or more of the Components is not type accepted. Please change you selection.
          </div>
        )}
        {selectedCombination.requiredRules.map(combinationSingleTypeHolder => {
          const availableTypesList = this.getAvailableTypesList(combinationSingleTypeHolder.componentTypeIds);
          const typeHolderExistingComponents = this.getAddedComponentsList(combinationSingleTypeHolder);
          const selectedType = this.getSelectedType(combinationSingleTypeHolder, availableTypesList);
          const componentAndManufacturerFieldDisabled =
            this.isMaxComponents(combinationSingleTypeHolder) || !selectedType;

          const isSteeringHelm = combinationSingleTypeHolder.id === 10 && selectedCombination.id === 6;

          return (
            <div key={combinationSingleTypeHolder.id} className='component-type-section'>
              <header className={`type-set-header ${this.getStyle(combinationSingleTypeHolder)}`}>
                <div
                  className={`type-set-quantity-label ${isSteeringHelm ? 'type-set-quantity-label_for-steering' : ''} ${
                    this.isMaxComponents(combinationSingleTypeHolder) === 'more' ? 'error' : ''
                  }`}
                >
                  {this.isMaxComponents(combinationSingleTypeHolder)
                    ? `Only ${combinationSingleTypeHolder.maxComponentQuantity} Component(s) can be added`
                    : ''}
                </div>
                <div className='type-name'>
                  {availableTypesList.length > 1 ? (
                    <Select
                      type={selectType.primarySmall}
                      label={isSteeringHelm ? 'Steering Helm Assembly' : ''}
                      withoutSearch
                      selectionList={availableTypesList}
                      defaultItem={selectedType}
                      placeholder='Please select...'
                      itemNameIndicator='value'
                      error={this.getStyle(combinationSingleTypeHolder) === 'error' ? ' ' : ''}
                      disabled={this.isMaxComponents(combinationSingleTypeHolder) || !availableTypesList.length}
                      handleSelect={handleTypeChose(combinationSingleTypeHolder.id)}
                    />
                  ) : (
                    selectSingleType(combinationSingleTypeHolder.id, availableTypesList[0])
                  )}
                </div>
                <div className='_flex'>
                  <Select
                    type={selectType.primarySmall}
                    mainWrapperClassName={`_margin_right_30 ${isSteeringHelm ? '_margin_top_22' : ''}`}
                    dropDownClassName='_max_height_120'
                    isLoading={loadedTypes[selectedTypes[combinationSingleTypeHolder.id]] === false}
                    selectionList={manufacturersList[selectedTypes[combinationSingleTypeHolder.id]]}
                    defaultItem={selectedManufacturersFilters[combinationSingleTypeHolder.id]}
                    handleSelect={handleSelectManufacturerFilter(combinationSingleTypeHolder.id)}
                    placeholder='Manufacturer'
                    disabled={componentAndManufacturerFieldDisabled}
                  />
                  <Select
                    type={selectType.primarySmall}
                    mainWrapperClassName={`${isSteeringHelm ? '_margin_top_22' : ''}`}
                    dropDownClassName='_max_height_120'
                    isLoading={loadedTypes[selectedTypes[combinationSingleTypeHolder.id]] === false}
                    selectionList={this.getAvailableComponentsList(combinationSingleTypeHolder.id)}
                    itemNameIndicator={['id', 'description']}
                    isSlave
                    defaultItem=''
                    handleSelect={this.handleSelectComponent(combinationSingleTypeHolder.id)}
                    error={this.getStyle(combinationSingleTypeHolder) === 'error' ? ' ' : ''}
                    placeholder={`${availableTypesList.length ? 'Type Accepted Number' : 'No Components found'}`}
                    disabled={componentAndManufacturerFieldDisabled}
                  />
                </div>
              </header>
              {typeHolderExistingComponents.length > 0 && (
                <div className='components-list selected'>
                  <div>
                    <div className='column manufacturer'>Manufacturer Name</div>
                    <div className='column id'>ID</div>
                    <div className='column type'>Type</div>
                    <div className='column description'>Description</div>
                    <div className='column qty'>Qty</div>
                    <div className='column action' />
                  </div>
                  {typeHolderExistingComponents.map(component => {
                    return (
                      <div key={component.id} className={invalidComponents[component.id] ? 'deprecated-component' : ''}>
                        <div className='column manufacturer'>{component.manufacturerName}</div>
                        <div className='column id'>{component.id}</div>
                        <div className='column type'>{component.componentType.componentTypeName}</div>
                        <div className='column description'>{component.description}</div>
                        <div className='column qty'>
                          <div
                            className={`${!component.quantity || component.quantity === 1 ? 'hidden' : ''}`}
                            onClick={updateQuantity(combinationSingleTypeHolder.id, component.id)}
                          >
                            -
                          </div>
                          {component.quantity || 1}
                          <div
                            className={`${
                              component.quantity < combinationSingleTypeHolder.maxQuantity ? '' : 'hidden'
                            }`}
                            onClick={updateQuantity(combinationSingleTypeHolder.id, component.id, true)}
                          >
                            +
                          </div>
                        </div>
                        <div className='column action'>
                          <div
                            className='delete'
                            onClick={removeComponent(combinationSingleTypeHolder.id, component.id)}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/AddComponents/CombinationSection.jsx